import { RootState } from "@/redux/store";

export const accreditationsSelector = (state: RootState) => state.accreditation.items;
export const accreditationsPageSelector = (state: RootState) => state.accreditation.page;
export const accreditationHistorySelector = (state: RootState) => state.accreditation.history.items;
export const accreditationHistoryPageSelector = (state: RootState) => state.accreditation.history.page;
export const accreditationsPageStateSelector = (state: RootState) => state.accreditation.pageState;
